module.exports = __webpack_public_path__ + "assets/img/detail2.23fd208e.png";